import { EMPTY_OBJECT } from '../../constants/common'
import { getApi } from '../../utils/api'

export function getWelcomePost() {
  return getApi({ endpoint: '/idwell-api/api/v3/news/welcome-post/' })
}

export function searchPosts(search, apiConfig = EMPTY_OBJECT) {
  return getApi({
    ...apiConfig,
    endpoint: `api/v2/newsband-tiny/`,
    params: { ...apiConfig.params, search },
  })
}
